/* eslint-disable import/prefer-default-export */
export const getCaregiverSelectionFlags = ({ user, caregiver }) => {
  const isCaregiver = !!user?.is_caregiver

  // Resolve selected participant from Redux or localStorage
  let selectedPtp = caregiver?.selected
  if (!selectedPtp) {
    try {
      selectedPtp = JSON.parse(localStorage.getItem('selected_ptp')) || null
    } catch (_) {}
  }

  // Resolve participants from Redux or sessionStorage
  let participants = caregiver?.participants || []
  if (!participants?.length) {
    try {
      const stored = sessionStorage.getItem('caregiver_participants')
      if (stored) {
        const parsed = JSON.parse(stored) || []
        if (Array.isArray(parsed)) participants = parsed
      }
    } catch (_) {}
  }

  const participantsCount = Array.isArray(participants) ? participants.length : 0
  const mustSelectParticipant = !!isCaregiver && !selectedPtp && participantsCount > 1

  return { isCaregiver, selectedPtp, participantsCount, mustSelectParticipant }
}


